import { Heading } from "@digipost/dds-heading-react";
import { faTriangleExclamation as faTriangleExclamationSolid } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, ReactNode } from "react";

import styles from "./ErrorPage.module.css";
import Translated from "./infrastructure/Translated";

type Props = {
  children?: ReactNode;
};

const ErrorPage: FC<Props> = ({ children }) => {
  return (
    <div className={styles.wrapper}>
      <Heading level={1} size="large">
        <FontAwesomeIcon
          icon={faTriangleExclamationSolid}
          className={styles.icon}
        />
        <Translated textKey="register.org.error.general_header" />
      </Heading>
      <div>{children}</div>
    </div>
  );
};

export default ErrorPage;
